/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import VueRouter from 'vue-router';
import routes from './routes';
// ES6 Modules or TypeScript
import Swal from 'sweetalert2'
import Chart from 'chart.js';
import html2canvas from 'html2canvas/dist/html2canvas.min.js';
import { Form, HasError, AlertError } from 'vform';
import VueProgressBar from 'vue-progressbar';
window.JSZip = require('jszip');
import 'datatables.net-bs4'
import "datatables.net-buttons";
import "datatables.net-buttons/js/buttons.html5";
import Gate from "./Gate";
import LiquorTree from 'liquor-tree';
import objectToFormData from 'object-to-formdata';

window.objectToFormData = objectToFormData;
Vue.prototype.$gate = new Gate(window.user);
window.html2canvas = html2canvas;
Vue.use(VueRouter);
Vue.use(LiquorTree);


window.Form = Form;
window.Swal = Swal;
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});
window.Toast = Toast;


Vue.prototype.$inputIdentifyColorAndFeedBack = function (e) {

    let inputValue = parseInt(e.target.value);

    let feedback = '';

    e.target.style.border = 'solid 1px #aaa';

    if (inputValue >= 0 && inputValue < 10) {
        feedback = 'Know-Nothing';
        e.target.style.borderBottom = 'solid 5px #eee';

    }
    else if (inputValue >= 10 && inputValue <= 25) {
        feedback = 'Know-What';
        e.target.style.borderBottom = 'solid 5px green';

    }
    else if (inputValue >= 26 && inputValue <= 60) {

        feedback = 'Know-How';
        e.target.style.borderBottom = 'solid 5px blue';


    }
    else if (inputValue >= 61 && inputValue <= 90) {

        feedback = 'Know-Why';
        e.target.style.borderBottom = 'solid 5px red';


    }
    else if (inputValue >= 91 && inputValue <= 100) {

        feedback = 'Innovation-Ninja';
        e.target.style.borderBottom = 'solid 5px black';

    }


}

const router = new VueRouter({
    mode: 'history',
    routes
});

const options = {
    color: '#1ddc1d',
    failedColor: '#ff0000',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
};

Vue.use(VueProgressBar, options);


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);
Vue.component('not-found', require('./components/NotFound.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    router
});
